import { REQUEST_STATUS } from "./roles";

export const CODE_CATEGORY_REQUIREMENT_TABLE = 27;
export const CODE_TYPE_REQUIREMENT_TABLE = 26;
export const REGISTROS_QUE_GENERAN_OBSERVACION = "31";
export const TIPO_ARCHIVO = {
  NO_MEDICOS: 1,
  REQUISITOS: 2
} as const;
export const ERROR_FILE_TYPE = "Tipo de archivo no permitido. Solo se permiten: PDF, XLS, XLSX, DOC, DOCX, TIF, JPG, MSG";
export const ERROR_FILE_TYPE_SYSTEM = "Tipo de archivo no permitido por el sistema.";
export const ERROR_FILE_SIZE = "Tamaño del archivo excede los 20 MB";
export const ERROR_UPLOAD_FILE = "Error al cargar el archivo. Intente nuevamente.";
export const MOTIVO_ANULACION_REQUISITO = 30;
export const CODIGO_TIPO_REQUISITO = {
  MEDICO: '1',
  NO_MEDICO: '2',
} as const;
export const MASTER_PARAMETERS = {
  GENERA_OBSERVACION: ["002", "009"],
} as const;
export const UPLOADED_IMAGE = {
  HAS_IMAGE: 'Si',
  NO_IMAGE: 'No',
} as const;

export const SALES_METHOD = {
  MANUAL: 1,
  DIGITAL: 4,
} as const;
export const ESTADO_REQUISITO = {
  NO_PROGRAMADO: 1,
  PROGRAMADO: 2,
  ANULADO: 3,
  REALIZADO: 4,
  NO_REALIZADO: 5,
  CONFIRMADO: 6,
  PENDIENTE_CANAL: 7,
  PENDIENTE_PACIFICO: 8,
} as const;
export const CODE_NATIONALITY_SEARCH_TABLE = '1';
export const CODE_SALES_CHANNEL_TABLE = 2;
export const CODE_TYPE_DOCUMENT_TABLE = 6;
export const CODE_TYPE_PROFESSION_TABLE = 18;
export const CODE_TYPE_OCCUPATION_TABLE = 19;
export const CODE_TYPE_STREET_TABLE = 10;
export const CODE_TYPE_INTERIOR_TABLE = 13;
export const CODE_TYPE_URBANIZATION_TABLE = 12;
export const CODE_TYPE_GENDER_TABLE = 7;
export const CODE_NATIONALITY_TABLE = 5
export const CODE_MARITAL_STATE_TABLE = 8
export const CODE_STATE_REQUEST = 16;
export const TYPE_HOUSING_COMPLEX = 11;
export const CODE_TYPE_CURRENCY_TABLE = 3;
export const CODE_TYPE_OF_CREDIT_TABLE = 15;
export const CODE_TYPE_REQUEST = 14;
export const CODE_TYPE_REQUEST_TABLE = 14;
export const CODE_EXCLUSION_COVERAGE_TABLE= 44;
export const CODE_CATEGORIA_REASON_REJECT_COVERAGE_TABLE = 23;
export const CODE_DOCUMENTS__DECLARATION_TABLE= 46;
export const CODE_POSTPONEMENT_PERIOD_COVERAGE_TABLE = 40;

export const CODE_PERCENTAGE_SURCHARGE_TABLE_BY_COUNTRY = 22;
export const CODE_REASON_COVERAGE_TABLE_BY_COUNTRY = 21;


export const CODE_TYPE_APPOINMENT_TABLE = 31;
export const STATE_APPOINMENT_MEDICAL = 29

export const PARAM_URL_IDREQUEST = "idRequest";

export const STATE_APPOINMENT = {
  NO_SCHEDULED: 1,
  FAILED: 2,
  CONFIRMED: 3,
  SCHEDULED: 4,
  COMPLETED: 5,
  NOT_COMPLETED: 6,
  CANCELLED: 7,
  UNREACHABLE: 8,
} as const;

export const LOCAL_STORAGE = "localStorage";
export const ID_REQUEST_NAME_STORAGE = "idRequest";
export const CURRENT_ID_ROLE_STORAGE = "currentIdRole";

export const DAYS_OF_WEEK = {
  SUNDAY: 0,
  MONDAY: 1,
  TUESDAY: 2,
  WEDNESDAY: 3,
  THURSDAY: 4,
  FRIDAY: 5,
  SATURDAY: 6,
} as const;

export const INSURANCE_TYPE = {
  INDIVIDUAL: 1,
  JOINT: 2,
  PYME: 3,
} as const;


export const MAX_PAGE_SIZE = Number(import.meta.env.VITE_MAX_PAGE_SIZE) || 10;

export const SLASH = '/';
export const ZERO = 0;
export const EMPTY_STRING = '';

export const TYPE_DOCUMENT = {
  DNI: 1,
  CE: 3,
  PASSPORT: 4,
  RUC: 2,
}

export const HALF_SALE = {
  MANUAL: 1,
  DIGITAL: 4,
};

export const STATES_REQUEST_FINISH = [
  REQUEST_STATUS.APPROVED,
  REQUEST_STATUS.CANCELED,
  REQUEST_STATUS.APPROVED_WITH_OBSERVATION,
  REQUEST_STATUS.REJECTED,
] as number[];

export const STATE_ENABLED_EVALUATE = [
  REQUEST_STATUS.NEW_REQUIREMENT_COMPLETED,
  REQUEST_STATUS.PENDING_REQUIREMENT,
  REQUEST_STATUS.REQUIREMENT_COMPLETED,
  REQUEST_STATUS.REVIEWED,
] as number[];

export const STATE_ENABLED_MENU_EVALUATE = [
  REQUEST_STATUS.PENDING_REQUIREMENT,
  REQUEST_STATUS.REQUIREMENT_COMPLETED
] as number[];

export const PREFIX_CURRENCY: Record<number, string> = {
  1: "S/ ",
  2: "$ ",
  3: "%",
};

export const TYPE_COVERAGE = {
  BASIC: 1,
  ADDITIONAL: 0,
} as const;

export const POLICY_ID = {
  PYME_REGULAR: 2,
  PYME_RETORNO: 6,
} as const;
export const ALLOWED_EXTENSIONS = [
  'pdf', 'xls', 'xlsx', 'doc', 'docx', 'tif', 'jpg', 'msg'
];
export const ALLOWED_MIME_TYPES = [
  'application/pdf',
  'application/vnd.ms-excel',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'image/tiff',
  'image/jpeg',
  'application/vnd.ms-outlook',
];
